// extracted by mini-css-extract-plugin
module.exports = {"container":"Articles_container__sPgoE","transparent":"Articles_transparent__VpMJ2"};